import { render, staticRenderFns } from "./JobFamiliesList.vue?vue&type=template&id=248cf62b&scoped=true"
import script from "./JobFamiliesList.vue?vue&type=script&setup=true&lang=js"
export * from "./JobFamiliesList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobFamiliesList.vue?vue&type=style&index=0&id=248cf62b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cf62b",
  null
  
)

export default component.exports